import { render } from "./BaseKeyboardComponent.vue?vue&type=template&id=29a1c61d&scoped=true"
import script from "./BaseKeyboardComponent.vue?vue&type=script&lang=js"
export * from "./BaseKeyboardComponent.vue?vue&type=script&lang=js"

import "./BaseKeyboardComponent.vue?vue&type=style&index=0&id=29a1c61d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a1c61d"]])

export default __exports__